import { useState } from 'react';
import axios from 'axios';

const useAxiosCallback = (configResolver: any) => {
    const [data, setData] = useState(undefined);
    const [response, setResponse] = useState(undefined);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [execCount, setExecCount] = useState(0);

    const fetchData = async (reqData: any, configResolver: any) => {
        try {
            setLoading(true);
            setError('');
            setResponse(undefined);
            setData(undefined);
            const params = await configResolver(reqData);
            const result = await axios.request(params);
            // @ts-expect-error TS2345: Argument of type 'AxiosResponse<any, any, >' is not assignable to parameter of type 'SetStateAction<
            setResponse(result);
            setData(result.data);
        } catch (err) {
            // @ts-expect-error TS2345: Argument of type 'unknown' is not assignable to parameter of type 'SetStateAction<string>'.
            setError(err);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const exec = (reqData: any) => {
        setExecCount(execCount + 1);
        fetchData(reqData, configResolver);
    };

    return [exec, loading, { error, response, data, execCount }];
};

export default useAxiosCallback;
